import BookingHistory from 'features/BookingDetails/BookingHistory'
import { useState } from 'react'

import styles from './GuestDetailsButton.module.scss'

const GuestDetailsButton = ({ subscriberId, onClose }) => {
  const [showBookingHistory, setShowBookingHistory] = useState(false)
  return (
    <>
      <button
        className={styles.reservationDetails}
        onClick={() => setShowBookingHistory(true)}
      >
        See reservation history →
      </button>
      {showBookingHistory && (
        <BookingHistory
          subscriberId={subscriberId}
          onClose={onClose}
          onBack={() => setShowBookingHistory(false)}
        />
      )}
    </>
  )
}

export default GuestDetailsButton
